import DeleteModifierGroupsModal from './DeleteModifierGroupsModal';
import ModifierGroupModal from './ModifierGroupModal';

export default {
  DeleteModifierGroupsModal,
  ModifierGroupModal,
};
